import {RatioScale} from './Scale';
import {RenderContext} from './RenderContext';
import {IChartOptions} from './ChartOptions';
import {Axis} from './Axis';
import {NumberUtils} from './Utils';

	export class GridConfiguration {

		public static MAJOR_UNIT_MINIUM_PX = RatioScale.PX_PER_CM;
		public static MINOR_UNIT_MINIMUM_PX = RatioScale.PX_PER_CM / 5;

		private static NO_GRID_CFG = {
			majorStep: 0,
			minorStep: 0,
			min:0,
			max: 0,
			scale: 1
		};

		/**
		 * Primary Y-Axis grid configuration.
		 * majorStep=0 means no grid should be displayed.
		 */
		public horizontal = GridConfiguration.NO_GRID_CFG;

		/**
		 * Primary X-Axis grid configuration.
		 * majorStep=0 means no grid should be displayed.
		 */
		public vertical = GridConfiguration.NO_GRID_CFG;

		/**
		 * Calculates and sets the 'horizontal' and 'vertical' properties of this grid configuration.
		 * Grid options are evaluated before any calculations are perfomed.
		 */
		public calculate(context: RenderContext, options: IChartOptions) {
			var axis = context.axesConfiguration.xAxes[0]; //get primary x-axis
			if(axis != undefined &&
				(options.grid.display == 'both' || options.grid.display == 'vertical')){


				if(options.grid.interval && options.grid.interval.x) {
					//set fixed grid from configuration
					this.vertical = {
								majorStep: options.grid.interval.x.major,
								minorStep: options.grid.interval.x.minor,
								min: axis.minimum,
								max: axis.maximum,
								scale: axis.scaleFactor
							};
				}
				else if(options.grid.intervalPX && options.grid.intervalPX.x) {
					//set fixed grid from configuration
					this.vertical = {
								majorStep: options.grid.intervalPX.x.major / axis.scaleFactor,
								minorStep: options.grid.intervalPX.x.minor / axis.scaleFactor,
								min: axis.minimum,
								max: axis.maximum,
								scale: axis.scaleFactor
							};
				}
				else if(options.grid.hint && options.grid.hint.x){
					this.vertical = this.getAutoUnits(axis, options.grid.hint.x.major, options.grid.hint.x.minor);
				}
				else {
					this.vertical = this.getAutoUnits(axis);
				}

			}
			else {
				this.vertical = GridConfiguration.NO_GRID_CFG;
			}

			var axis = context.axesConfiguration.yAxes[0]; //get primary y-axis
			if(axis != undefined &&
				(options.grid.display == 'both' || options.grid.display == 'horizontal')){


				if(options.grid.interval && options.grid.interval.y) {
					//set fixed grid from configuration
					this.horizontal = {
								majorStep: options.grid.interval.y.major,
								minorStep: options.grid.interval.y.minor,
								min: axis.minimum,
								max: axis.maximum,
								scale: axis.scaleFactor
							};
				}
				else if(options.grid.intervalPX && options.grid.intervalPX.y) {
					//set fixed grid from configuration
					this.horizontal = {
								majorStep: options.grid.intervalPX.y.major / axis.scaleFactor,
								minorStep: options.grid.intervalPX.y.minor / axis.scaleFactor,
								min: axis.minimum,
								max: axis.maximum,
								scale: axis.scaleFactor
							};
				}
				else if(options.grid.hint && options.grid.hint.y){
					this.horizontal = this.getAutoUnits(axis, options.grid.hint.y.major, options.grid.hint.y.minor);
				}
				else {
					this.horizontal = this.getAutoUnits(axis);
				}

			}
			else {
				this.horizontal = GridConfiguration.NO_GRID_CFG;
			}
		}

		private getAutoUnits(axis: Axis,
			majorHint: number = GridConfiguration.MAJOR_UNIT_MINIUM_PX,
			minorHint: number = GridConfiguration.MINOR_UNIT_MINIMUM_PX) {

			var major = NumberUtils.niceRound(majorHint / axis.scaleFactor);
			var minor = minorHint * major / majorHint;

			return {
				majorStep: major,
				minorStep: minor,
				min: axis.minimum,
				max: axis.maximum,
				scale: axis.scaleFactor
			}
		}

	}
